module.exports = __webpack_public_path__ + "static/media/throttle.f952b9df.png";